export const Units = {
    METERS: 'METERS',
    FEET: 'FEET'
}
